require.register("app/restaurant/show/UserTab", function(exports, require, module){
  $0
  
});

